import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Command } from '../../../models/internal/command';

@Component({
  selector: 'app-commands',
  templateUrl: './commands.component.html',
  styleUrls: [
    '../../guild-dashboard/shared/styles/guild-dashboard-shared.css',
    './commands.component.css'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommandsComponent {
  displayedColumns: string[] = ['command', 'description', 'usage', 'help'];

  @Input()
  commands: Command[];

  constructor() { }
}
